// 3. Hook pour la gestion des erreurs
// hooks/useErrorHandler.ts
import { useNavigate } from 'react-router-dom';

export const useErrorHandler = () => {
  const navigate = useNavigate();

  const handleError = (error: unknown): string => {
    let errorMessage = "Une erreur est survenue lors de l'enregistrement: ";
    
    if (typeof error === "object" && error !== null && "message" in error) {
      errorMessage += (error as { message?: string }).message || "Erreur inconnue";
    } else {
      errorMessage += "Erreur inconnue";
    }

    // Gestion spécifique des erreurs d'authentification
    if (errorMessage.includes("403") || errorMessage.includes("Forbidden")) {
      errorMessage = "Accès refusé. Vérifiez vos permissions ou reconnectez-vous.";
      
      // Nettoyage du localStorage
      localStorage.removeItem("token");
      localStorage.removeItem("userId");
      localStorage.removeItem("role");
      localStorage.removeItem("userEmail");
      localStorage.removeItem("userLabel");
      
      // Redirection vers la page de connexion
      setTimeout(() => {
        navigate("/login");
      }, 2000);
    }

    return errorMessage;
  };

  return { handleError };
};